function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0.666504 9.01284C0.666504 4.62293 4.17484 0.666992 9.0165 0.666992C13.7498 0.666992 17.3332 4.54781 17.3332 8.98781C17.3332 14.1372 13.1332 17.3337 8.99984 17.3337C7.63317 17.3337 6.1165 16.9664 4.89984 16.2487C4.47484 15.99 4.1165 15.798 3.65817 15.9482L1.97484 16.449C1.54984 16.5825 1.1665 16.2487 1.2915 15.798L1.84984 13.9286C1.9415 13.6698 1.92484 13.3944 1.7915 13.1774C1.07484 11.8588 0.666504 10.4149 0.666504 9.01284ZM7.9165 9.01284C7.9165 9.6054 8.3915 10.0811 8.98317 10.0895C9.57484 10.0895 10.0498 9.6054 10.0498 9.02119C10.0498 8.42863 9.57484 7.95292 8.98317 7.95292C8.39984 7.94457 7.9165 8.42863 7.9165 9.01284ZM11.7582 9.02119C11.7582 9.6054 12.2332 10.0895 12.8248 10.0895C13.4165 10.0895 13.8915 9.6054 13.8915 9.02119C13.8915 8.42863 13.4165 7.95292 12.8248 7.95292C12.2332 7.95292 11.7582 8.42863 11.7582 9.02119ZM5.1415 10.0895C4.55817 10.0895 4.07484 9.6054 4.07484 9.02119C4.07484 8.42863 4.54984 7.95292 5.1415 7.95292C5.73317 7.95292 6.20817 8.42863 6.20817 9.02119C6.20817 9.6054 5.73317 10.0811 5.1415 10.0895Z",
  fill: "#FFCB0B"
});
function SvgMessagesYellowIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessagesYellowIcon);
export default __webpack_public_path__ + "static/media/messages-yellow-icon.a38ebede.svg";
export { ForwardRef as ReactComponent };